import { render, staticRenderFns } from "./JMTZAll.vue?vue&type=template&id=986bf324&scoped=true&"
import script from "./JMTZAll.vue?vue&type=script&lang=js&"
export * from "./JMTZAll.vue?vue&type=script&lang=js&"
import style0 from "./JMTZAll.vue?vue&type=style&index=0&id=986bf324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986bf324",
  null
  
)

export default component.exports